module.exports = __webpack_public_path__ + "assets/89889688147bd7575d6327160d64e760.svg";


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap/dist/fonts/glyphicons-halflings-regular.svg
// module id = 360
// module chunks = 36